export default __webpack_public_path__ + "static/media/rest_01.97ac74e6.jpg";